import { useState } from 'react';
import { SelectPlus } from 'Components/SelectPlus';
import { useGetBrands } from '@features/vehicles/hooks/useVehicles';
import { useDebounce } from '@shared/hooks/useDebounce';

export const SelectBrand = ({ mode = 'single', onSearch, ...selectProps }) => {
  const [searchText, setSearchText] = useState('');

  // page_size grande: el catálogo viejo pagina con un lote pequeño y, al venir ordenado
  // alfabéticamente, sin esto solo se listarían las marcas que empiezan por A.
  const { data, isFetching } = useGetBrands({ searchText, pageSize: 500 });

  const records = data?.results ?? [];

  const isSingleMode = mode === 'single';
  const placeholder = `Seleccionar ${isSingleMode ? 'marca' : 'marcas'}`;

  const options = records.map((record) => ({
    value: record.brand,
    label: record.brand,
    record,
  }));

  const debouncedSetSearchText = useDebounce(setSearchText);

  const handleSearch = (newSearchText) => {
    debouncedSetSearchText(newSearchText);
    onSearch?.(newSearchText);
  };

  return (
    <SelectPlus
      mode={mode}
      placeholder={placeholder}
      loading={isFetching}
      options={options}
      onSearch={handleSearch}
      filterOption={false} // Se desactiva filtrado interno, ya que se maneja manualmente
      {...selectProps}
    />
  );
};
